export const formatCurrencyFn = (
  amount: number,
  currency = import.meta.env.VITE_DEFAULT_CURRENCY || "USD"
) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(amount);
